import React from 'react'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    formataMesAnoComBarra,
} from '../../../business-components/Date/Date'

import {
    TablePaginationPadrao,
    rowPertentePage,
    setPageInclusao,
    setPageExclusao,
} from '../../../business-components/Pagination/Pagination'

import {
    TextValidatorText,
    TextValidatorNumber,
    TextValidatorNumberRequired,
    TextValidatorValor,
    TextValidatorValorRequired,
    TextValidatorTextMultiline,
    TextValidatorMesAno,
    TextValidatorMesAnoRequired,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldTextSelect,
    TextFieldNumberSelect,
    TextFieldNumberSelectRequired,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import tipoFinanciamentoEntradaDadosList from '../../../business-rules/List/tipoFinanciamentoEntradaDadosList'

import simNaoList from '../../../business-rules/List/simNaoList'

import tipoGrupoDespesaList from '../../../business-rules/List/tipoGrupoDespesaList'

import {
    IconButtonClearEntradaDados,
    IconButtonHelp,
} from '../../../business-components/IconButton/IconButton'

import {
    calculaValoresMesesFinanciamento,
} from '../estudo-form/EstudoServiceDespesasFinanciamento'

import {
    processaAlteracaoFinanciamentoTipoFinanciamento,
    processaCalculoFinanciamentoTabelaSAC,
    tituloFinanciamentoPercSeguroCliente,
    tituloFinanciamentoPercSeguroConjuge,
    tituloFinanciamentoAlterarPercSeguroConjuge,
    processaAlteracaoFinanciamentoTemSeguro,
    processaAlteracaoFinanciamentoPercSeguroCliente,
    processaAlteracaoFinanciamentoFinanciamentoFuturo,
} from './DespesasServiceFinanciamento'



export const TablePaginationPadraoFinanciamento = ({ values, setFieldValue }) => {

    return (
        <TablePaginationPadrao
            setFieldValue={setFieldValue}
            list={values.financiamentoPagination}
            nameRowsPerPage={'rowsPerPageFinanciamento'}
            namePage={'pageFinanciamento'}
            rowsPerPage={values.rowsPerPageFinanciamento}
            page={values.pageFinanciamento}
        />
    )
}

export const rowPertentePageFinanciamento = (values, indAux) => {
    
    return rowPertentePage(indAux, values.pageFinanciamento, values.rowsPerPageFinanciamento)
}

export const setPageInclusaoFinanciamento = (values, setFieldValue) => {

    return setPageInclusao(setFieldValue, 'pageFinanciamento', values.financiamentoPagination, values.rowsPerPageFinanciamento)
}



export const Familiar = ({ values, item, ind, handleChange, expandiu }) => {

    return (
        <TextFieldNumberSelect
            name={`financiamento[${ind}].familiar`}
            label={LABEL.familiar}
            value={item.familiar || ''}
            onChange={handleChange}
            list={values.totalFinanciamento}
            disabled={expandiu}
        />
    )
}

export const TipoFinanciamento = ({ TextFieldNumberSelectTipoFinanciamento, item, ind, handleChange, expandiu }) => {

    return (
        <TextFieldNumberSelectTipoFinanciamento
            name={`financiamento[${ind}].tipoFinanciamento`}
            placeholder={LABEL.tipoFinanciamento}
            value={item.tipoFinanciamento || ''}
            onChange={handleChange}
            list={tipoFinanciamentoEntradaDadosList(item.tipoFinanciamento)}
            onBlur={processaAlteracaoFinanciamentoTipoFinanciamento(item)}
            disabled={expandiu}
        />
    )
}

export const IconButtonClearEntradaDadosFinanciamento = ({ values, setFieldValue, ind, arrayHelpers, simplificado }) => {

    return (
        !simplificado
            ? 
                <IconButtonClearEntradaDados
                    onClick={() => {
                        arrayHelpers.remove(ind)
                        setPageExclusao(setFieldValue, 'pageFinanciamento', values.financiamentoPagination, values.rowsPerPageFinanciamento,
                            values.pageFinanciamento)
                    }}
                />
            :
                ''
    )
}

export const TabelaSAC = ({ values, item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`financiamento[${ind}].tabelaSAC`}
            label={LABEL.tabelaSAC}
            checked={item.tabelaSAC}
            onChange={handleChange}
            onBlur={processaCalculoFinanciamentoTabelaSAC(values, item)}
        />
    )
}

export const Consorcio = ({ item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`financiamento[${ind}].consorcio`}
            label={LABEL.consorcio}
            checked={item.consorcio}
            onChange={handleChange}
        />
    )
}

export const ValorParcela = ({ item, ind, label, handleChange, disabled }) => {

    return (
        <TextValidatorValorRequired
            name={`financiamento[${ind}].valorParcela`}
            label={label}
            value={item.valorParcela || ''}
            onChange={handleChange}
            disabled={disabled}
        />
    )
}

export const QtdeParcelas = ({ values, item, ind, label, handleChange, expandiu }) => {

    const { mesFinal, anoFinal } = calculaValoresMesesFinanciamento(values, item, false)

    return (
        <TextValidatorNumberRequired
            name={`financiamento[${ind}].qtdeParcelas`}
            label={label + (item.qtdeParcelas ? ' (' + formataMesAnoComBarra(mesFinal, anoFinal) + ')' : '')}
            value={item.qtdeParcelas || ''}
            onChange={handleChange}
            numMin={NUMMIN.qtdeParcelas}
            numMax={NUMMAX.qtdeParcelas}
            onBlur={processaCalculoFinanciamentoTabelaSAC(values, item)}
            disabled={expandiu}
        />
    )
}

export const ValorTotalParcelas = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorValor
            name={`financiamento[${ind}].valorTotalParcelas`}
            label={LABEL.valorTotalParcelas}
            value={item.valorTotalParcelas || ''}
            onChange={handleChange}
            disabled={true}
        />
    )
}

export const ValorSaldoDevedor = ({ TextValidatorValorValorSaldoDevelor, values, item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorValorValorSaldoDevelor
            name={`financiamento[${ind}].valorSaldoDevedor`}
            label={LABEL.valorSaldoDevedor}
            value={item.valorSaldoDevedor || ''}
            onChange={handleChange}
            onBlur={processaCalculoFinanciamentoTabelaSAC(values, item)}
            disabled={expandiu}
        />
    )
}

export const HelpValorSaldoDevedor = () => {
    
    return (
        <IconButtonHelp
            helpTitle={LABEL.valorSaldoDevedor}
            helpText={HELPTEXT.valorSaldoDevedor}
        />
    )
}

export const TemSeguro = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextFieldTextSelect
            name={`financiamento[${ind}].temSeguro`}
            label={LABEL.temSeguro}
            value={item.temSeguro || ''}
            onChange={handleChange}
            list={simNaoList}
            onBlur={processaAlteracaoFinanciamentoTemSeguro(item)}
            disabled={expandiu}
        />
    )
}

export const PercSeguroCliente = ({ values, item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorNumberRequired
            name={`financiamento[${ind}].percSeguroCliente`}
            label={tituloFinanciamentoPercSeguroCliente(values)}
            value={item.percSeguroCliente === 0 ? 0 : item.percSeguroCliente || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
            onBlur={processaAlteracaoFinanciamentoPercSeguroCliente(item)}
            disabled={expandiu}
        />
    )
}

export const PercSeguroConjuge = ({ values, item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorNumber
            name={`financiamento[${ind}].percSeguroConjuge`}
            label={tituloFinanciamentoPercSeguroConjuge(values)}
            value={item.percSeguroConjuge === 0 ? 0 : item.percSeguroConjuge || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
            disabled={!item.alterarPercSeguroConjuge || expandiu}
        />
    )
}

export const AlterarPercSeguroConjuge = ({ values, item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`financiamento[${ind}].alterarPercSeguroConjuge`}
            label={tituloFinanciamentoAlterarPercSeguroConjuge(values)}
            checked={item.alterarPercSeguroConjuge}
            onChange={handleChange}
        />
    )
}

export const PercSeguro = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumber
            name={`financiamento[${ind}].percSeguro`}
            label={LABEL.perc}
            value={item.percSeguro === 0 ? 0 : item.percSeguro || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
        />
    )
}

export const HelpTemSeguro = () => {
    
    return (
        <IconButtonHelp
            helpTitle={LABEL.temSeguro}
            helpText={HELPTEXT.temSeguro}
        />
    )
}

export const FinanciamentoFuturo = ({ item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`financiamento[${ind}].financiamentoFuturo`}
            label={LABEL.financiamentoFuturo}
            checked={item.financiamentoFuturo}
            onChange={handleChange}
            onBlur={processaAlteracaoFinanciamentoFinanciamentoFuturo(item)}
        />
    )
}

export const MesAnoInicial = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorMesAnoRequired
            name={`financiamento[${ind}].mesAnoInicial`}
            label={LABEL.mesAnoInicial}
            value={item.mesAnoInicial || ''}
            onChange={handleChange}
        />
    )
}

export const HelpMesAnoInicial = () => {
    
    return (
        <IconButtonHelp
            helpTitle={LABEL.financiamentoFuturo}
            helpText={HELPTEXT.financiamentoFuturo}
        />
    )
}

export const FinanciamentoFuturoAindaNaoContratado = ({ item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`financiamento[${ind}].financiamentoFuturoAindaNaoContratado`}
            label={LABEL.financiamentoFuturoAindaNaoContratado}
            checked={item.financiamentoFuturoAindaNaoContratado}
            onChange={handleChange}
            onBlur={processaAlteracaoFinanciamentoFinanciamentoFuturo(item)}
        />
    )
}

export const HelpFinanciamentoFuturoAindaNaoContratado = () => {
    
    return (
        <IconButtonHelp
            helpTitle={LABEL.financiamentoFuturoAindaNaoContratado}
            helpText={HELPTEXT.financiamentoFuturoAindaNaoContratado}
        />
    )
}

export const FinanciamentoSeraQuitadoAntesUltimaParcela = ({ item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`financiamento[${ind}].financiamentoSeraQuitadoAntesUltimaParcela`}
            label={LABEL.financiamentoSeraQuitadoAntesUltimaParcela}
            checked={item.financiamentoSeraQuitadoAntesUltimaParcela}
            onChange={handleChange}
        />
    )
}

export const UltimaParcelaFinanciamento = ({ values, item, ind, handleChange }) => {

    const { mesFinal, anoFinal } = calculaValoresMesesFinanciamento(values, item, true)

    return (
        <TextValidatorNumberRequired
            name={`financiamento[${ind}].ultimaParcelaFinanciamento`}
            label={
                LABEL.ultimaParcela +
                    (item.ultimaParcelaFinanciamento ? ' (' + formataMesAnoComBarra(mesFinal, anoFinal) + ')' : '')
            }
            value={item.ultimaParcelaFinanciamento || ''}
            onChange={handleChange}
            numMin={NUMMIN.qtdeParcelas}
            numMax={item.qtdeParcelas}
        />
    )
}

export const HelpFinanciamentoSeraQuitadoAntesUltimaParcela = () => {
    
    return (
        <IconButtonHelp
            helpTitle={LABEL.financiamentoSeraQuitadoAntesUltimaParcela}
            helpText={HELPTEXT.financiamentoSeraQuitadoAntesUltimaParcela}
        />
    )
}

export const ConsumirRecursosFinanceirosEmVezDaReceitaMensal = ({ item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`financiamento[${ind}].consumirRecursosFinanceirosEmVezDaReceitaMensal`}
            label={LABEL.consumirRecursosFinanceirosEmVezDaReceitaMensal}
            checked={item.consumirRecursosFinanceirosEmVezDaReceitaMensal}
            onChange={handleChange}
        />
    )
}

export const HelpConsumirRecursosFinanceirosEmVezDaReceitaMensal = () => {
    
    return (
        <IconButtonHelp
            helpTitle={LABEL.consumirRecursosFinanceirosEmVezDaReceitaMensal}
            helpText={HELPTEXT.consumirRecursosFinanceirosEmVezDaReceitaMensalFinanciamento}
        />
    )
}

export const GrupoDespesa = ({ item, ind, handleChange }) => {

    return (
        <TextFieldNumberSelectRequired
            name={`financiamento[${ind}].grupoDespesa`}
            label={LABEL.grupoDespesa}
            value={item.grupoDespesa || ''}
            onChange={handleChange}
            list={tipoGrupoDespesaList}
        />
    )
}

export const PossuiParcelasAdicionais = ({ item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`financiamento[${ind}].possuiParcelasAdicionais`}
            label={LABEL.possuiParcelasAdicionais}
            checked={item.possuiParcelasAdicionais}
            onChange={handleChange}
        />
    )
}

export const Instituicao = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorText
            name={`financiamento[${ind}].instituicao`}
            label={LABEL.instituicao}
            value={item.instituicao || ''}
            onChange={handleChange}
            tamMax={TAMMAX.instituicao}
        />
    )
}

export const MesAnoPrimeiroReajuste = ({ TextValidatorMesAnoRequiredPrimeiroReajuste, item, ind, handleChange }) => {

    return (
        <TextValidatorMesAnoRequiredPrimeiroReajuste
            name={`financiamento[${ind}].mesAnoPrimeiroReajuste`}
            label={LABEL.mesAnoPrimeiroReajuste}
            value={item.mesAnoPrimeiroReajuste || ''}
            onChange={handleChange}
        />
    )
}

export const TaxaAnual = ({ TextValidatorNumberRequiredTaxaAnual, values, item, ind, handleChange }) => {

    return (
        <TextValidatorNumberRequiredTaxaAnual
            name={`financiamento[${ind}].taxaAnual`}
            label={LABEL.taxaAnual}
            value={item.taxaAnual === 0 ? 0 : item.taxaAnual || ''}
            onChange={handleChange}
            numMin={NUMMIN.taxa}
            numMax={NUMMAX.taxa}
            onBlur={processaCalculoFinanciamentoTabelaSAC(values, item)}
        />
    )
}

export const TaxaAnualTR = ({ values, item, ind, handleChange }) => {

    return (
        <TextValidatorNumber
            name={`financiamento[${ind}].taxaAnualTR`}
            label={LABEL.taxaAnualTR}
            value={item.taxaAnualTR === 0 ? 0 : item.taxaAnualTR || ''}
            onChange={handleChange}
            numMin={NUMMIN.taxa}
            numMax={NUMMAX.taxa}
            onBlur={processaCalculoFinanciamentoTabelaSAC(values, item)}
        />
    )
}

export const HelpTaxaAnualConsorcio = () => {
    
    return (
        <IconButtonHelp
            helpTitle={LABEL.taxaAnual}
            helpText={HELPTEXT.taxaAnualConsorcio}
        />
    )
}

export const DescricaoOutros = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorText
            name={`financiamento[${ind}].descricaoOutros`}
            label={LABEL.descricao}
            value={item.descricaoOutros || ''}
            onChange={handleChange}
            tamMax={TAMMAX.descricaoFinanciamentolOutros}
            notToUpperCase={true}
            disabled={expandiu}
        />
    )
}

export const HelpDescricaoOutros = () => {
    
    return (
        <IconButtonHelp
            helpTitle={LABEL.descricao}
            helpText={HELPTEXT.descricaoFinanciamentolOutros}
        />
    )
}

export const ValorCreditoConsorcio = ({ item, ind, handleChange }) => {

    return (

        <TextValidatorValor
            name={`financiamento[${ind}].valorCreditoConsorcio`}
            label={LABEL.valorCreditoConsorcio}
            value={item.valorCreditoConsorcio === 0 ? 0 : item.valorCreditoConsorcio || ''}
            onChange={handleChange}
        />
    )
}

export const PrazoTotalGrupoConsorcio = ({ item, ind, handleChange }) => {

    return (

        <TextValidatorNumber
            name={`financiamento[${ind}].prazoTotalGrupoConsorcio`}
            label={LABEL.prazoAtualGrupoConsorcio}
            value={item.prazoTotalGrupoConsorcio === 0 ? 0 : item.prazoTotalGrupoConsorcio || ''}
            onChange={handleChange}
            numMin={NUMMIN.prazoTotalGrupoConsorcio}
            numMax={NUMMAX.prazoTotalGrupoConsorcio}
        />
    )
}

export const TaxaAdministracao = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumber
            name={`financiamento[${ind}].taxaAdministracao`}
            label={LABEL.taxaAdministracaoAbreviado}
            value={item.taxaAdministracao === 0 ? 0 : item.taxaAdministracao || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
        />
    )
}

export const PercFundoReserva = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumber
            name={`financiamento[${ind}].percFundoReserva`}
            label={LABEL.percFundoReserva}
            value={item.percFundoReserva === 0 ? 0 : item.percFundoReserva || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
        />
    )
}

export const PercRedutorParcela = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumber
            name={`financiamento[${ind}].percRedutorParcela`}
            label={LABEL.percRedutorParcela}
            value={item.percRedutorParcela === 0 ? 0 : item.percRedutorParcela || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
        />
    )
}

export const PercSeguroPrestamista = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumber
            name={`financiamento[${ind}].percSeguroPrestamista`}
            label={LABEL.percSeguroPrestamista}
            value={item.percSeguroPrestamista === 0 ? 0 : item.percSeguroPrestamista || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
        />
    )
}

export const ValorCreditoConsorcioContemplacao = ({ item, ind, handleChange }) => {

    return (

        <TextValidatorValor
            name={`financiamento[${ind}].valorCreditoConsorcioContemplacao`}
            label={
                item.tipoFinanciamento === HARDCODE.idTipoFinanciamentoImovel && !item.consorcioGerado
                    ?
                        LABEL.valorImovel
                    :
                        LABEL.valorCreditoConsorcioContemplacaoAbreviado
            }
            value={item.valorCreditoConsorcioContemplacao === 0 ? 0 : item.valorCreditoConsorcioContemplacao || ''}
            onChange={handleChange}
        />
    )
}

export const MesAnoInicialAluguelAposContemplacao = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorMesAno
            name={`financiamento[${ind}].mesAnoInicialAluguelAposContemplacao`}
            label={LABEL.mesAnoInicialAluguelAposContemplacao}
            value={item.mesAnoInicialAluguelAposContemplacao || ''}
            onChange={handleChange}
        />
    )
}

export const PercAluguelMensalAposContemplacao = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumber
            name={`financiamento[${ind}].percAluguelMensalAposContemplacao`}
            label={LABEL.percAluguelMensalAposContemplacao}
            value={item.percAluguelMensalAposContemplacao === 0 ? 0 : item.percAluguelMensalAposContemplacao || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
        />
    )
}

export const PercReajusteAluguelAnualAposContemplacao = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumber
            name={`financiamento[${ind}].percReajusteAluguelAnualAposContemplacao`}
            label={LABEL.percReajusteAluguelAnualAposContemplacao}
            value={
                item.percReajusteAluguelAnualAposContemplacao === 0
                    ?
                        0
                    :
                        item.percReajusteAluguelAnualAposContemplacao || ''
            }
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
        />
    )
}

export const ValorAluguelAposContemplacao = ({ item, ind, handleChange }) => {

    return (

        <TextValidatorValor
            name={`financiamento[${ind}].valorAluguelAposContemplacao`}
            label={LABEL.valorAluguelAposContemplacao}
            value={item.valorAluguelAposContemplacao === 0 ? 0 : item.valorAluguelAposContemplacao || ''}
            onChange={handleChange}
            disabled={item.tipoFinanciamento === HARDCODE.idTipoFinanciamentoImovel && !item.consorcioGerado}
        />
    )
}

export const PercValorizacaoImovelAluguelAposContemplacao = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumber
            name={`financiamento[${ind}].percValorizacaoImovelAluguelAposContemplacao`}
            label={LABEL.percValorizacaoImovelAluguelAposContemplacao}
            value={item.percValorizacaoImovelAluguelAposContemplacao === 0 ? 0 : item.percValorizacaoImovelAluguelAposContemplacao || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
        />
    )
}

export const MesAnoVendaAposQuitacao = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorMesAno
            name={`financiamento[${ind}].mesAnoVendaAposQuitacao`}
            label={LABEL.mesAnoVendaAposQuitacao}
            value={item.mesAnoVendaAposQuitacao || ''}
            onChange={handleChange}
        />
    )
}

export const Observacao = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorTextMultiline
            name={`financiamento[${ind}].observacao`}
            label={LABEL.observacao}
            value={item.observacao || ''}
            onChange={handleChange}
            tamMax={TAMMAX.observacao}
        />
    )
}